export default "/fonts/mydevicon.ttf?539f8d574994c9568c754b9a327f23ef";